// window.open('mailto:...') spawns a blank tab and fails silently when no
// mail handler is registered; navigating the current tab is the reliable
// protocol handoff (the browser prompts for a handler when needed).
export function openMailto (to: string, subject: string, body: string) {
  window.location.href = `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
